import {
  Avatar as MantineAvatar,
  type AvatarProps as MantineAvatarProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type AvatarProps = CoreComponentProps<MantineAvatarProps, 'div'>;

export function Avatar({ testId, view = "all", ...rest }: AvatarProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineAvatar data-testid={testId} {...rest} />;
}
